export default __webpack_public_path__ + "static/media/mons4.a3fc8a9a.jpg";